module.exports = __webpack_public_path__ + "img/4. latest project.4cdd0510.png";